import React, { useEffect, useState } from 'react';
import { Quote } from 'lucide-react';
import { siteConfig } from '../../config/site';

const stats = [
  { value: 150000, suffix: '+', label: 'hectáreas analizadas' },
  { value: 5000, suffix: '+', label: 'reportes generados' },
  { value: 120, suffix: '+', label: 'asesores y productores activos' },
];

const testimonials = [
  {
    quote:
      'Bajé la ambientación en KML desde SpecifiC, la abrí en Google Earth y fui recorriendo el lote. En un momento pasás de una zona a otra y se nota clarísimo — no hace falta ser agrónomo para verlo.',
    name: 'Carlos M.',
    role: 'Productor, Pergamino',
  },
  {
    quote:
      'Antes armaba esto en QGIS y me llevaba horas. Acá lo tengo listo en minutos, con una mejor correlación de ambientes. Es más simple para explicarle a mis clientes.',
    name: 'Valentín S.',
    role: 'Ing. Agrónomo',
  },
];

function StatCounter({ value, suffix, label }) {
  const [display, setDisplay] = useState(0);
  const ref = React.useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      const duration = 1500;
      const start = performance.now();
      const tick = (now) => {
        const p = Math.min((now - start) / duration, 1);
        setDisplay(Math.floor((1 - Math.pow(1 - p, 3)) * value));
        if (p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
      observer.disconnect();
    }, { threshold: 0.3 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [value]);

  return (
    <div ref={ref} className="text-center">
      <p className="font-display text-3xl font-bold text-brand-dark md:text-4xl">
        {display.toLocaleString('es-AR')}
        {suffix}
      </p>
      <p className="mt-1 text-sm text-brand-earth">{label}</p>
    </div>
  );
}

export function TrustSection() {
  return (
    <section id={siteConfig.anchors.trust} className="bg-white py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 text-center">
          <p className="text-xs font-semibold uppercase tracking-wide text-brand-accent">En el campo</p>
          <h2 className="mt-2 font-display text-3xl font-bold text-brand-dark">
            Usado por agrónomos y productores en todo el país
          </h2>
        </div>

        <div className="mb-12 grid gap-8 sm:grid-cols-3">
          {stats.map((s) => (
            <StatCounter key={s.label} {...s} />
          ))}
        </div>

        <div className="grid gap-6 md:grid-cols-2">
          {testimonials.map((t) => (
            <div key={t.name} className="rounded-2xl border border-brand-dark/5 bg-surface p-6 shadow-card">
              <Quote className="h-8 w-8 text-brand-accent/40" />
              <p className="mt-3 text-sm leading-relaxed text-brand-earth">&ldquo;{t.quote}&rdquo;</p>
              <p className="mt-4 font-semibold text-brand-dark">{t.name}</p>
              <p className="text-xs text-brand-earth">{t.role}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
